import { useMemo } from 'react';
import { debounce } from 'lodash';
import { useEventListener } from './useEventListener';

export const useResize = (callback, wait = 250) => {
  const handleResize = useMemo(() => {
    return wait !== 0 ? debounce((e) => callback(e), wait) : (e) => callback(e)
  }, [wait, callback]);

  useEventListener({ type: 'resize', listener: handleResize, options: { passive: true } });
}